import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmToastComponent } from './mm-toast.component';



@NgModule({
  declarations: [MmToastComponent],
  imports: [
    CommonModule
  ],
  exports: [
    MmToastComponent
  ]
})
export class MmToastModule { }
